var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifiOutline = function SvgWifiOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.58 15.874a.75.75 0 0 0 1.061 1.06zm7.779 1.06a.75.75 0 0 0 1.06-1.06zM12 19.25a.75.75 0 1 0 0 1.5zm.01 1.5a.75.75 0 0 0 0-1.5zM4.4 12.399a.75.75 0 0 0 1.06 1.06zm14.142 1.06a.75.75 0 0 0 1.06-1.06zM.863 8.863a.75.75 0 0 0 1.06 1.06zm21.213 1.06a.75.75 0 0 0 1.061-1.06zM8.641 16.935a4.75 4.75 0 0 1 6.718 0l1.06-1.06a6.25 6.25 0 0 0-8.838 0zm3.36 3.816h.01v-1.5H12zm-6.542-7.29a9.25 9.25 0 0 1 13.082 0l1.06-1.061C15.405 8.2 8.598 8.2 4.4 12.399zM1.924 9.923c5.565-5.565 14.588-5.565 20.152 0l1.061-1.06c-6.15-6.152-16.123-6.152-22.274 0z"
  })));
};
export default SvgWifiOutline;